import { render, staticRenderFns } from "./Space.vue?vue&type=template&id=9a1e0768&scoped=true"
import script from "./Space.vue?vue&type=script&lang=js"
export * from "./Space.vue?vue&type=script&lang=js"
import style0 from "./Space.vue?vue&type=style&index=0&id=9a1e0768&prod&lang=stylus&scoped=true"
import style1 from "./Space.vue?vue&type=style&index=1&id=9a1e0768&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a1e0768",
  null
  
)

export default component.exports